export default {
    install: function(Vue) {
    
      Vue.prototype.$utils = {
        
        file_limit: 10,

        /**
         * 隨機取得一個十六進制的顏色
         *
         * @param {string}
         */
        randomHexColor() {
          return '#' + Math.floor(Math.random()*16777215).toString(16);
        },
        /**
         * 更新麵包屑，強迫顯示要取代的麵包屑
         *
         * @param {...string} names - 需要顯示在麵包屑中的名稱串列，每個名稱代表一層。
         */
        updateBreadcrumbs(...names) {
          const breadcrumbs = names.map(name => ({ text: name }));
          this.$store.commit('update_breadcrumbs', breadcrumbs);
        },
        /**
         * 在物件中，根據給定的值找尋對應的鍵。
         *
         * @param {Object} object - 需要搜索的物件。
         * @param {*} value - 要找尋的值。
         * @returns {(string|undefined)} 如果找到，則返回給定值的鍵，否則返回 undefined。
         *
         * @example
         * let obj = {a: 1, b: 2, c: 3};
         * console.log(getKeyByValue(obj, 2));  // 輸出: "b"
         */
        getKeyByValue(object, value) {
          return Object.entries(object).find(([, val]) => val === value)?.[0]
        },
        parseDateFormat(dateString) {
            let date = new Date(dateString);

            if (date === 'Invalid Date') {
                // alert('有非法的日期')
                return ""
            }
            
            let year = date.getFullYear();
            let month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份是從 0 開始的，所以需要加 1
            let day = date.getDate().toString().padStart(2, '0');
            let hours = date.getHours().toString().padStart(2, '0');
            let minutes = date.getMinutes().toString().padStart(2, '0');
            let seconds = date.getSeconds().toString().padStart(2, '0');

            if(date.toString() === 'Invalid Date') {
              return ""
            } else {
              return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
            }
        },
        /**
         * @description 根據給定的正則表達式來驗證一個 URL 字串
         *
         * @param {string} Regex - 用來匹配的正則表達式模式。
         * @param {string} url_val - 需要驗證的 URL 字串。
         * @return {boolean} - 如果 URL 符合該模式則返回 true，否則返回 false。
         */
        validateByRegex(Regex, url_val) {
          let pattern = new RegExp(Regex)
          return !!pattern.test( decodeURIComponent( decodeURIComponent(url_val) ) )
        },

        /**
         * @description 根據給定的正則表達式來驗證一個 URL 字串，此函數將忽略大小寫。
         *
         * @param {string} Regex - 用來匹配的正則表達式模式。
         * @param {string} url_val - 需要驗證的 URL 字串。
         * @return {boolean} - 如果 URL 符合該模式則返回 true，否則返回 false。
         */
        validateByRegexIgnoreCase(Regex, url_val) {
          let pattern = new RegExp(Regex, 'i')
          return !!pattern.test( decodeURIComponent( decodeURIComponent(url_val) ) )
        },

        /**
         * @description 通過指定的元素 id 平滑滾動至該元素位置。
         *
         * @param {string} id_name - 需要滾動至的 HTML 元素的 id。
         * 
         * @returns {void} 若找到目標元素，將視窗滾動至該元素；否則，記錄錯誤消息。
         * 
         * @source https://blog.csdn.net/weixin_42776027/article/details/120522684
         */
        scroll_to(id_name) {
            console.log("滾囉");
            let targetElement = document.querySelector(`#${id_name}`);
            if(targetElement) {
                let elementPosition = targetElement.offsetTop;
                elementPosition += targetElement.offsetParent.offsetTop
                if (id_name === 'count_down_timer_setting_name') {
                  elementPosition -= 70
                }
                if (id_name === 'basic-setting') {
                  elementPosition -= 200
                }
                if (id_name === 'normal-setting') {
                  elementPosition -= 125
                }
                console.log(elementPosition)
                window.scrollTo({
                    top: elementPosition,
                    behavior: "smooth",
                    block: "start"
                });
                // return true
            } else {
                console.log(`Element with id ${id_name} not found`);
            }
            
        },
        scroll_to_in_ele(parent_ele_id, top) {
          let parent_ele = document.querySelector(`#${parent_ele_id}`);
          parent_ele.scrollTo({
            top: top,
            behavior: "smooth",
            block: "start"
          });

        },
        validateUrl: function(url_val) {
          const pattern = /^(https?:\/\/).*/i;
          return !!pattern.test(decodeURIComponent(url_val));
        },
        checkEmail:function(email) {
            return String(email)
            .toLowerCase()
            .match(
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
        },

        goPage: function(pathname){
          Vue.$router.push(pathname)
        },

        getBase64File: async function(url) {
          return await fetch(url).then(
            res => res.arrayBuffer()
          )
        },
        field_rules: {
          checkDomain: (val) => {
              if (val.match('https://')) {
                return val.startsWith(process.env.VUE_APP_DOMAIN) || '網域輸入錯誤'
              }
              return true
          },
          validateUrlAndHost: (val) => {
            const url_pattern = /^(https?:\/\/).*/i;
            const domain_pattern = /^(?:(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)\.)+(?:[a-z]{2,})$/i;
            const url_val = decodeURIComponent(val) 


            let url_result = url_pattern.test(url_val)
            let domain_result = domain_pattern.test(url_val)
            console.log('url_result:', url_result);
            console.log('domain_result:', domain_result);

            if (url_result || domain_result) {
              return true
            }
            else {
              return '網址格式錯誤'
            }
          },
          validateUrl: url_val => {
            const pattern = /^(https?:\/\/).*/i;
            console.log(url_val);
            console.log(pattern.test(url_val));
            return url_val !== null || url_val !== "" ? !!pattern.test(decodeURIComponent(url_val)) || '必填欄位，網址格式錯誤' : '必填欄位'
          },
          validateHost: host => {
            const pattern = /^(?:(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)\.)+(?:[a-z]{2,})$/i;
            console.log(host);
            return host ? !!pattern.test(host) || '網域格式錯誤' : '必填欄位'
          },
          required: value => !!value || '必填欄位',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Email格式錯誤'
          },
          isCustomerEmailExist: async function(value) {
            console.log('exist')
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            let result = true
            if (!pattern.test(value)) {
              console.log('?')
              return false
            }
            else {
              console.log('??')
              return result
            }

          },
          verifyId: (id) => {
            id = id.trim();

            let verification = id.match("^[A-Z][12]\\d{8}$")
            if(!verification){
                return '身分證格式錯誤'
            }

            let conver = "ABCDEFGHJKLMNPQRSTUVXYWZIO"
            let weights = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1]

            id = String(conver.indexOf(id[0]) + 10) + id.slice(1);

            let checkSum = 0
            for (let i = 0; i < id.length; i++) {
                let c = parseInt(id[i])
                let w = weights[i]
                checkSum += c * w
            }

            if (checkSum % 10 == 0) {
               return  true
            }
            else {
                return '身分證格式錯誤'
            }
          },
          phone: (value) => {
            if (value.length !== 10) {
                return '電話號碼格式錯誤'
            } 
            else {
                if (value.match(/\d/g) && (value.match(/\d/g)).length === 10) {
                    return true
                }
                else {
                    return '電話號碼格式錯誤'
                }
            }
          },
          number: value => {
            if (value.length > 3) {
              return '格式錯誤'
            }
            return true
          },
          onlyEng: value => {
            if (value) {
              console.log(/^[a-zA-Z]$/.test(value))
              if (/^[a-zA-Z]+$/.test(value)) {
                return true
              }
              else {
                return '格式錯誤'
              }
              
            }
            else {
              return true
            }
          },
          isNonNegativeNumber: (char) => {
            const number = parseInt(char);
            if (!isNaN(number) && number >= 0) {
              return true
            }
            else {
              return '格式錯誤'
            }
          },
          isOnlyNumber(input) {
            // 利用isNaN函数检查是否为数字
            let result = ''
            if (!isNaN(input)) {
              // 检查是否为负数
              if (parseFloat(input) >= 0) {
                result = true;
              }
              else {
                result = '格式錯誤'
              }
            }
            else {
              result = '格式錯誤'
            }
            console.log('result',result)
            return result
          },
          date(input_string){
            try {
              let t_date = new Date(input_string)
              console.log('t_date', t_date)
              if (isNaN(t_date)) {
                return '格式錯誤'
              }
              else {
                return true
              }
              
            } catch (error) {
              return '格式錯誤'
            }
          },
          biggerThanLen: (str, expected_len) => {
            str = str.toString()
            if (str.length < expected_len) {
              return `長度至少超過 ${expected_len}`
            }
            else {
              return true
            }

          },
        },
        goBackHome: function() {
          Vue.$router.push('/home')
        },
        throttle(fn, delay = 500) {
          let timer = null;
        
          return (...args) => {
            if (timer) return;
            timer = setTimeout(() => {
              fn(...args);
              timer = null;
            }, delay);
          };
        },
        debounce() {
          // let timer;
        },
        createDomByHtmlString: function(html_string) {
          var div = document.createElement('div');
          div.innerHTML = html_string.trim();
          return div.firstChild; 
        },
        rgbStingToArray: function(rgb_string) {
          let rgb = rgb_string.replace(/rgb| /g,'').replace('(', '').replace(')', '').split(',')
          //console.log(rgb);
          return rgb;
        },
        rgbToHex: function(r,g,b) {
          return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
        },
        componentToHex: function(c) {
          var hex = c.toString(16);
          //console.log(hex);
          return hex.length == 1 ? "0" + hex : hex;
        },
        getYYYYMMDDHHMMSS: function(dateString, delimiter){
          console.log('dateString', typeof(dateString))
          console.log('dateString', dateString)

          // 建立新的 Date 物件
          let date = new Date();

          if (dateString) {
            if (typeof(dateString) === 'string' && dateString.includes(' ')) {
              dateString = dateString.replace(' ', 'T')
              date = new Date(dateString)
            }
            else if (typeof(dateString) === 'object'){
              date = dateString
            }
            else {
              date = new Date(dateString)
            }
          
          }
          
          // 取得年份
          const year = date.getFullYear();
          
          // 取得月份
          let month = date.getMonth() + 1;
          month = month < 10 ? '0' + month : month;
          
          // 取得日期
          let day = date.getDate();
          day = day < 10 ? '0' + day : day;
          
          // 取得小時
          let hours = date.getHours();
          hours = hours < 10 ? '0' + hours : hours;
          
          // 取得分鐘
          let minutes = date.getMinutes();
          minutes = minutes < 10 ? '0' + minutes : minutes;
          
          // 取得秒數
          let seconds = date.getSeconds();
          seconds = seconds < 10 ? '0' + seconds : seconds;
          
          // 格式化日期和時間
          const formattedDateTime = `${year}${delimiter}${month}${delimiter}${day} ${hours}:${minutes}:${seconds}`;
          
          return formattedDateTime;
        },
        updateSelectedElement(doc, data, type){
          const target_ele = doc.querySelector(data.selector)
          if (!target_ele) {
              return
          }
          switch (data.type) {
              case 'attribute':
                  this.updateAttribute(data, type, target_ele)
                  break
              case 'css':
                  this.updateStyle(data, type, target_ele)
                  break;
              case 'html':
                  this.updateHTML(data, type, target_ele)
          }
        },
        updateAttribute(data, type, target_ele) {
            if (type === 'next') {
                target_ele.setAttribute(data.attribute, data.new_value)
                
                // for shopline lazy load img會顯示不出來的問題 要一起改data-src
                if (data.nodeName === 'IMG') {
                    if (target_ele.hasAttribute('data-src')) {
                        target_ele.setAttribute('data-src', data.new_value)
                    }
                }
            }
            else {
                target_ele.setAttribute(data.attribute, data.value)
    
                // for shopline lazy load img會顯示不出來的問題 要一起改data-src
                if (data.nodeName === 'IMG') {
                    if (target_ele.hasAttribute('data-src')) {
                        target_ele.setAttribute('data-src', data.value)
                    }
                }
            }
            
        },
        updateStyle(data, type, target_ele) {
            if (type === 'next') {
                target_ele.style.setProperty(data.css, data.new_value);
            }
            else {
                target_ele.style.setProperty(data.css, data.value);
            }
        },
        updateHTML(data, type, target_ele) {
            switch(data.method) {
                case 'replaceText':
                    if (type === 'next') {
                        target_ele.innerHTML = data.new_value
                    }
                    else {
                        target_ele.innerHTML = data.value
                    }
                    break;
            }
        },
        formatNumberWithCommas(number) {
          // 使用正则表达式将数字转换为千分位逗号格式
          return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        toIsoString(date_string) {
          if (!date_string.includes('T')) {
            date_string = date_string.replace(/-/g,'/')
          }
          let date = new Date(date_string)
          var tzo = -date.getTimezoneOffset(),
              dif = tzo >= 0 ? '+' : '-',
              pad = function(num) {
                  return (num < 10 ? '0' : '') + num;
              };
          return date.getFullYear() +
              '-' + pad(date.getMonth() + 1) +
              '-' + pad(date.getDate()) +
              'T' + pad(date.getHours()) +
              ':' + pad(date.getMinutes()) +
              ':' + pad(date.getSeconds()) +
              dif + pad(Math.floor(Math.abs(tzo) / 60)) +
              ':' + pad(Math.abs(tzo) % 60);
        },
        displayISOString(date_string){
          let date = ''
          if (typeof(date_string) === 'string' || typeof(date_string) === 'number') {
            date = new Date(date_string);
          }
          else {
            date = date_string
          }

          if (!date) {
            return 
          }

          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');
        
          const output = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        
          return output;
        },
        openURL(to_url, params, is_original) {
          let url = to_url
          if (!is_original) {
            url = decodeURIComponent(decodeURIComponent(to_url))
          } 
          console.log('url:', url)
          if (url.indexOf('https://') === -1) {
            url = `https://${url}`
          }
          console.log('url:', url)
          window.open(url,'_blank', params)
        },
        copyText(text){
          navigator.clipboard.writeText(text);
        },
        calculateDate(time_count){
          const end = new Date();
          end.setTime(end.getTime() + time_count * 24 * 3600 * 1000);

          return end
        },
        getCustomDateRange(start_at, end_at, symbol) {
          for(var arr=[],dt=new Date(start_at); dt<=new Date(end_at); dt.setDate(dt.getDate()+1)){
              let date_format = this.getYYYYMMDD(new Date(dt), symbol)
              arr.push(date_format);
          }
          return arr;
        },
        getYYYYMMDD(date, symbol){
          let date_format = ''
        
          date_format += date.getFullYear().toString() + symbol
          if (date.getMonth() + 1 < 10) {
            date_format += '0'
          }
          date_format += (date.getMonth() + 1).toString() + symbol
        
          if (date.getDate() < 10) {
            date_format += '0'
          }
          date_format += date.getDate().toString()
          return date_format
        },
        calculateDateOffset(offsetDays, target_date) {
          let currentDate = new Date();
          if (target_date) {
            currentDate = new Date(target_date)
          }
          currentDate.setDate(currentDate.getDate() + offsetDays);
        
          // 取得年、月、日
          let year = currentDate.getFullYear();
          let month = ('0' + (currentDate.getMonth() + 1)).slice(-2); // 加 1 是因為月份從 0 開始
          let day = ('0' + currentDate.getDate()).slice(-2);
      
          // 格式化日期
          let formattedDate = year + '-' + month + '-' + day;
      
          return formattedDate;
        },
        timeFormatMonitor(original_date, type = 'default') {
          if (!original_date) {
              return ''
          }
          if (original_date.includes(' ')) {
            original_date = original_date.replace(' ', 'T')
          }
          const timestamp = new Date(original_date)
          const year = timestamp.getFullYear()
          const month = String(timestamp.getMonth() + 1).padStart(2, '0')
          const day = String(timestamp.getDate()).padStart(2, '0')
          const hour = String(timestamp.getHours()).padStart(2, '0')
          const minute = String(timestamp.getMinutes()).padStart(2, '0')
          const second = String(timestamp.getSeconds()).padStart(2, '0')
          const default_format = `${year}-${month}-${day} ${hour}:${minute}`
          const model = {
              default: default_format,
              second: `${default_format}:${second}`
          }
          return model[type]
        },
        checkFileSize(file){
          let result = {}
          if (!file) {
            result = {
              result: false,
              size: '',
              expected: this.file_limit,
              default_msg: `請選擇檔案。`
            }
            return result
          }
          const file_size = (file.size / (1024 * 1024)).toFixed(2); // 轉換為 MB
          if (file_size > this.file_limit) {
            result = {
              result: false,
              size: file_size,
              expected: this.file_limit,
              default_msg: `檔案超過${this.file_limit}MB，請重新選擇，目前大小: ${file_size} MB 。`
            }
          }
          else {
            result = {
              result: true,
              size: file_size,
              expected: this.file_limit,
              default_msg: ``
            }
          }

          return result
        },
        splitObjectArrayBySize(arr, maxSize) {
          const result = [];
          let currentChunk = [];
          let currentSize = 0;
      
          for (const obj of arr) {
              const objSize = new TextEncoder().encode(JSON.stringify(obj)).length; // 計算物件的字串大小（bytes）
      
              if (currentSize + objSize > maxSize) {
                  result.push(currentChunk);
                  currentChunk = [];
                  currentSize = 0;
              }
      
              currentChunk.push(obj);
              currentSize += objSize;
          }
      
          if (currentChunk.length > 0) {
              result.push(currentChunk);
          }
      
          return result;
        },
        async getFile(url) {
          try {
              const response = await fetch(url, {
                method: 'GET',
              });
      
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
      
              return await response.text();
          } catch (error) {
              console.error('Error fetching file:', error);
              return null;
          }
        },
        date_picker_shorcuts: [
          {
            text: '今天',
            onClick() {
              const date = new Date();
              date.setHours(0, 0, 0, 0);
              // return a Date
              return date;
            },
          },
        ]
      };

    }
}
